import React from "react";
import {
  Container,
  VStack,
  Heading,
  Text,
  Button,
  Center,
  PinInput,
  PinInputField,
  HStack,
  Spacer,
  Box,
  IconButton,
  useColorModeValue,
} from "@chakra-ui/react";
import { colors } from "../../theme/index";
import { useDispatch, useSelector } from "react-redux";
import { verifyUser, setLogin } from "../../state";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import VerifyOtp from "./signUpApi/verifyAccountApi";
import { ReactComponent as LynxSplash } from "./lynx_spash.svg";
import ErrorAlert from "../../components/ErrorAlert";

const VerifyScreen = () => {
  const bgColor = useColorModeValue(colors.bgColorLight, colors.bgColorDark);
  const textColor = useColorModeValue("white", "white");
  const [showPassword, setShowPassword] = React.useState(true);
  const [error, setError] = React.useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const rollNo = useSelector((state) => state.registration.user_roll_no);
  const otp = useSelector((state) => state.registration.user_otp);


  const handleContinue = async () => {
  try {
    const response = await VerifyOtp(rollNo,Number(otp));
    const token = response.token;
    //console.log(response);
    const user = response.name;
    if (token) {
      dispatch(setLogin({ user: user, token: token }));
      navigate("/register-details"); 
    }
  } catch (error) {
    if (!navigator.onLine) {
      setError("No Internet connection");
      return;
    }

    const message = error?.response?.data?.message;

    const knownMessages = [
      "Invalid OTP or OTP expired",
      "OTP Expired",
      "Wrong OTP",
      "User not found",
      "Invalid roll number",
      "Roll number does not exist in our database",
      "Please fill in all the required fields",
    ];

    if (knownMessages.includes(message)) {
      setError(message);
    } else {
      setError("Server Error. Please try again!");
    }
  }
};


  const handleView = () => {
    setShowPassword(!showPassword);
  };

  const handlePrev = () => {
    navigate("/register-rollNo");
  };

  return (
    <HStack justify={"center"} spacing={0} h={"100vh"} overflow="hidden">
      <Container h="100vh" w="100%" mx={0} px={0}>
        <Center h="full">
          <VStack spacing={12} w={{ base: "90%", md: "100%" }}>
            <VStack spacing={[0.1, 0.5, 1]}>
              <Heading fontWeight={700}>Verify your Account</Heading>
              <Text
                color={colors.secondary}
                fontWeight={400}
                fontSize={{ base: "0.75em", md: "0.85em" }}
              >
                Enter the OTP sent on your webmail
              </Text>
            </VStack>
            <VStack spacing={4} w="100%">
              {error && <ErrorAlert message={error} />}
              <Box w="full" maxW={{ base: "90%", md: "50%" }} p="1%">
                <HStack>
                  <Center>
                    <PinInput
                      size="md"
                      otp
                      mask={showPassword}
                      onChange={(value) =>
                        dispatch(verifyUser({ user_otp: value }))
                      }
                    >
                      {Array(6)
                        .fill("")
                        .map((_, index) => (
                          <PinInputField
                            key={index}
                            w="16%" // Increased width
                            h="35px" // Increased height
                            mx="1%"
                            borderRadius={5}
                            bg={bgColor}
                            color={textColor}
                            textAlign="center"
                            fontSize="2xl" // Optional: Adjust font size
                          />
                        ))}
                    </PinInput>
                    <IconButton
                      aria-label={
                        showPassword ? "Show Password" : "Hide Password"
                      }
                      icon={showPassword ? <ViewIcon /> : <ViewOffIcon />}
                      size="md"
                      onClick={handleView}
                    />
                  </Center>
                </HStack>
              </Box>
              <Spacer h="1%" />
              <Button
                w="full"
                maxW={{ base: "90%", md: "50%" }}
                colorScheme="brand"
                borderRadius="4px"
                onClick={handleContinue}
              >
                Continue
              </Button>
              <Button
                w={"full"}
                maxW={{ base: "90%", md: "50%" }}
                variant={"ghost"}
                borderRadius={"4px"}
                onClick={handlePrev}
              >
                Back
              </Button>
            </VStack>
          </VStack>
        </Center>
      </Container>
      <Center h={"full"} m={0} p={0} display={{ base: "none", md: "flex" }}>
        <LynxSplash style={{ height: "90%" }} />
      </Center>
    </HStack>
  );
};

export default VerifyScreen;
